import { Component } from "react";
import { graphql } from "gatsby";
import styles from "./restaurant-menu-block.module.less";
import { OutlineButton, extract } from "@parksandresorts/core";
import RestaurantMenuListItem from "components/block-elements/restaurant-menu-list-item/restaurant-menu-list-item";
import borderPatterns from "styles/theming/border-patterns.module.less";
import { motion } from "framer-motion";

export default class RestaurantMenuBlock extends Component {
  constructor(props) {
    super(props);

    this.menuLists = extract(props, "menuLists", []);
    this.menuIngress = extract(props, "menuIngress");
    this.headline = extract(props, "headline");
    this.borderPattern = extract(props, "borderPattern");

    this.state = {
      listOpenState: this.createListOpenState(this.menuLists),
    };
  }

  createListOpenState(menuList) {
    const listOpenState = {};

    if (!menuList) {
      return {};
    }

    menuList.forEach((menu) => {
      listOpenState[menu.id] = typeof menu.isExpanded === "boolean" ? menu.isExpanded : true;
    });

    return listOpenState;
  }

  toggleMenuOpen(menuId) {
    this.setState({
      listOpenState: {
        ...this.state.listOpenState,
        [menuId]: !this.state.listOpenState[menuId],
      },
    });
  }

  render() {
    return (
      <section
        className={["block block--floating block--max-width", borderPatterns[this.borderPattern + "_bottom"]].join(" ")}
        data-contentful-id={this.props.contentful_id}
      >
        <div className={[styles.menuListWrapper].join(" ")}>
          {this.headline && <h2 className={styles.headline}>{this.headline}</h2>}
          {this.menuIngress && <p className={[styles.ingress, "preamble"].join(" ")}>{this.menuIngress}</p>}
          {this.menuLists.map((menu) => {
            return (
              <div key={menu.id} className={styles.listWrapper}>
                <div role="button" onClick={() => this.toggleMenuOpen(menu.id)} className={styles.headingWrapper}>
                  {menu.headline && (
                    <h3 className={styles.listHeadline}>
                      {menu.headline}
                      <div
                        className={[
                          styles.listItemCounter,
                          this.state.listOpenState[menu.id] ? styles.listItemCounter__hidden : "",
                        ].join(" ")}
                      >
                        {"(" + menu.listObjects.length + ")"}
                      </div>
                    </h3>
                  )}
                  <OutlineButton
                    className={styles.hideButton}
                    iconCenterNew={!this.state.listOpenState[menu.id] && "add"}
                    label={this.state.listOpenState[menu.id] && "Dölj"}
                    onClick={() => this.toggleMenuOpen(menu.id)}
                  />
                </div>
                <motion.div
                  className={[styles.list, this.state.listOpenState[menu.id] ? styles.open : styles.closed].join(" ")}
                  animate={{ height: this.state.listOpenState[menu.id] ? "auto" : 0 }}
                >
                  {menu.listObjects &&
                    menu.listObjects.map((listItem, index) => {
                      return <RestaurantMenuListItem key={listItem.id} {...listItem} />;
                    })}
                </motion.div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

export const fragmentRestaurantMenuBlock = graphql`
  fragment RestaurantMenuBlock on ContentfulRestaurantMenuBlock {
    contentful_id
    id
    headline
    menuIngress: ingress
    borderPattern
    menuLists {
      id
      headline
      isExpanded
      listObjects {
        __typename
        ... on ContentfulRestaurantMenuItem {
          id
          name
          price
          description
        }
      }
    }
  }
`;
